import * as React from 'react';
import { BASE_URL } from '../../../../config/environmentConfig';
import { paymentsActionTypes } from '../payments-action-types';
import { IPaymentsAction } from '../payments-interfaces';
import { GET } from '../../store-helper';

interface IPaymentInstrumentsData {
  dispatch: React.Dispatch<IPaymentsAction>;
  token: string;
}
export const fetchPaymentInstrumentsData = async ({ dispatch, token }: IPaymentInstrumentsData): Promise<void> => {
  try {
    dispatch({ type: paymentsActionTypes.FETCH_PAYMENT_INSTRUMENT_DATA_LOADING, payload: true });
    const data = await GET({
      pathname: `${BASE_URL.PAYMENTS}/paymentInstruments/${token}/token`
    });

    dispatch({ type: paymentsActionTypes.FETCH_PAYMENT_INSTRUMENT_DATA, payload: data ?? null });
  } catch (e) {
    dispatch({ type: paymentsActionTypes.FETCH_PAYMENT_INSTRUMENT_DATA, payload: null });
    console.log(e);
  }
};